import Vue from 'vue'
import posthog from 'posthog-js'

const PostHogPlugin = {
  /**
   * Install the PostHog plugin.
   * @param {vue} Vue - The Vue constructor.
   */
  install(vue) {
    posthog.init('phc_3Rg07TEDcrN58jdXEVPN7UfQbu5u3pS4aLo7okcFQLA', {
      api_host: 'https://onclock.xyz/visits',
      ui_host: 'https://us.posthog.com',
      capture_pageviews: false,
    })

    // eslint-disable-next-line no-param-reassign
    vue.prototype.$posthog = posthog
  },
}

Vue.use(PostHogPlugin)
